export const EVENT_NAMES = {
  CHANGE_PASSWORD: 'change_password',
  COMPANY_CONTACT: 'company_contact',
  DOWNLOAD_PROJECT: 'download_project',
  ERROR: 'error',
  EXPORT_PROJECT_LIST: 'export_project_list',
  FILTER_PROJECTS: 'filter_projects',
  GROUP_CONFIG_ACTION: 'group_config_action',
  LOGIN: 'login',
  LOGOUT: 'logout',
  MAIN_NAVIGATION: 'main_navigation',
  MAP_CLICK: 'map_click',
  MER_AUTHENTICATION: 'mer_authentication',
  NEW_USER: 'new_user',
  PAGE_VIEW: 'page_view',
  PROJECT_LIST_CLICK: 'project_list_click',
  PROJECT_MATERIALS: 'project_materials',
  REQUEST_INFO: 'request_info',
  SAVE_PROJECT: 'save_project',
  SEARCH: 'search',
  SECONDARY_NAVIGATION: 'secondary_navigation',
  SHARE: 'share',
  SHARE_PROJECT: 'share_project',
  VIEW_PROJECT_DETAILS: 'view_project_details',
  VIEW_STAGE_DETAILS: 'view_stage_details_modal',
  AI_RESEARCH_ASSISTANT: 'ai_research_assistant',
  SAVE_COMPANY: 'save_company',
  LOGIN_WITH_SSO: 'login_with_sso',
  REGISTER_WITH_SSO: 'register_with_sso',
  LINK_ACCOUNT_WITH_SSO: 'link_account_with_sso',
  IMPORT_COMPANIES: 'import_companies',
  SCOUT_AGENT: 'scout_agent',
  ENRICH_CONTACT: 'enrich_contact',
  PROJECT_NOTE: 'project_note',
} as const;

export type AnalyticsEventTypes = (typeof EVENT_NAMES)[keyof typeof EVENT_NAMES];
